<template>
  <div id="custom_table" class="main-tab">
    <ul class="list">
      <li>
        <span>上级</span>
        <span>{{baseInfoData.parentId ? baseInfoData.parentId : ''}}</span>
      </li>
      <li>
        <span>分销渠道</span>
        <span>{{baseInfoData.channelName ? baseInfoData.channelName : ''}}</span>
      </li>
      <li>
        <span>分销等级</span>
        <span>{{getLevel(baseInfoData.level)}}</span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'comTable',
  components: {},
  directives: {

  },
  props: ['baseInfoData', 'getLevel'],
  data() {
    return {
      tableColumns: this.columnName
    }
  },
  created() {

  },
  computed: {

  },
  mounted() {

  },
  methods: {}
}
</script>
<style type="text/scss" lang="scss" scoped>
$borderColor: #dcdfe6;
.main-tab{
  // width:60%;
  .list {
    width: 845px;
    border-radius: 4px;
    border: 1px solid $borderColor;
    border-bottom: none;
    li {
      list-style: none;
      height: 46px;
      border-bottom: 1px solid $borderColor;
      span {
        color: #111;
        display: inline-block;
        vertical-align: top;
        text-align: center;
        width: 48%;
        font-size: 14px;
        line-height: 46px;
        height: 46px;
        border-right: 1px solid $borderColor;
      }
      span:last-child {
        border-right: none;
        width: 50%;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/_app/outlet/src/views/memberBaseInfo/comTable/index.vue